export const scale = (size) => {
    return size;
};

export const verticalScale = (size) => {
    return size;
};

export const moderateScale = (size) => {
    return size;
};
